const api = {
  getCaseRevisions: controlNumber => `/homeowner/cases/${controlNumber}/form-data/revisions`,
  compareCaseRevisions: (controlNumber, fromRevision, toRevision) => `/homeowner/cases/${controlNumber}/form-data/revisions/${fromRevision}/compare/${toRevision}`,
};

export { api };
